import { render } from "./TemporaryPasses.vue?vue&type=template&id=6fc2a1f2&scoped=true"
import script from "./TemporaryPasses.vue?vue&type=script&lang=js"
export * from "./TemporaryPasses.vue?vue&type=script&lang=js"

import "./TemporaryPasses.vue?vue&type=style&index=0&id=6fc2a1f2&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc2a1f2"]])

export default __exports__